import { API } from "../apis/APIsConfig";
import Constants from "../utils/constants";

export function sendJobRequest(data) {
  return API.post(Constants.APIURLS.JOBREQUEST, data);
}
